export enum InsuranceType {
  Mmp = 'MMP',
  Mmqb = 'MQMB',
  SsiMedicaid = 'SSI MEDICAID',
}
